import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

/**
 * ProgressBar Component
 *
 * Renders a progress bar with dynamic steps based on the provided array of step names.
 * The active step is determined by the activeStep prop, starting from 0.
 *
 * @param {Object} props - The props object containing steps and activeStep.
 * @param {string[]} props.steps - An array of strings representing the names of each step.
 * @param {number} props.activeStep - A number indicating the active step (starting from 0).
 * @returns {JSX.Element} - The rendered progress bar component.
 */

export const ProgressBar = ({ steps, activeStep }) => {
  const ref = useRef(null);
  const stepItems = steps.map((step, index) => {
    const isActive = index === activeStep;
    const isCompleted = index < activeStep;
    return (
      <React.Fragment key={index}>
        <div
          className={`step${isCompleted ? ' step--complete' : isActive ? ' step--active' : ''}`}
          data-step={step}
        >
          {index + 1}
        </div>
        {index !== steps.length - 1 && <div className={`dashed-line`}/>}
      </React.Fragment>
    );
  });

  return (
    <div ref={ref} className={'sign-up__progress-bar'}>
      <div className="steps">{stepItems}</div>
    </div>
  );
};

ProgressBar.propTypes = {
  steps: PropTypes.arrayOf(PropTypes.string).isRequired,
  activeStep: PropTypes.number.isRequired,
};
